import { ReactNode } from 'react';
import { ActionType } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import ModalHeader, { ModalHeaderProps } from '../../legacy/React/Components/Common/ModalHeader';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';

interface SidebarTitleProps extends Pick<ModalHeaderProps, 'actions' | 'tabsConfig'> {
    onClose?: () => void;
    showTitle?: boolean;
    title?: ReactNode;
}

/** @deprecated Use new Sidebar from DS vision */
export default ({ showTitle = false, actions, onClose, title, tabsConfig }: SidebarTitleProps) => {
    const closeAction: HeadingAction = {
        type: ActionType.Link,
        icon: IconName.CrossClose,
        'data-test-icon-button': IconName.CrossClose,
        onClick: () => onClose?.(),
    };
    return showTitle ? (
        <ModalHeader actions={actions} primaryAction={closeAction} tabsConfig={tabsConfig}>
            {title}
        </ModalHeader>
    ) : null;
};
